jQuery(document).ready(function($) {
	var windowWidth = $(window).width()
		var playerEl = $('.login-page iframe');
		playerEl = playerEl[0];
		setTimeout(function(){
			var videoDimensions = getVideoDimensions(playerEl);

			$(playerEl).css({
				'height': videoDimensions.height,
				'width': videoDimensions.width,
			});
		}, 250);


		// Vimeo JS
		function getVideoDimensions(element) {
		var parentWidth = $(element).outerWidth();
		var parentHeight = $(element).outerHeight();

		var parentRatio = parentWidth / parentHeight;

		var videoWidth;
		var videoHeight;

		var ratio = 16 / 9;

		if (parentRatio >= ratio) {
			videoWidth = parentWidth;
			videoHeight = parentWidth / ratio;
		} else {
			videoHeight = parentHeight;
			videoWidth = (parentHeight / 9) * 16;
		}
		return {
			width: videoWidth,
			height: videoHeight
		};
	}
});
